import { StepShell } from '../components/layout';
import { Checkbox, Note } from '../components/inputs';

export default function ConsentStep({ data, update, notes = {}, config }) {
  const consents = data.consents || {};

  const toggle = (key, value) => {
    update({ consents: { ...consents, [key]: value } });
  };

  return (
    <StepShell
      eyebrow="Step 18 of 18"
      title="Your information, your call"
      lede="Before you send this off, here is exactly what happens to what you have written."
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {config.consentItems.map((item) => (
          <div key={item.key}>
            <Checkbox
              id={`consent_${item.key}`}
              label={item.label}
              hint={item.required ? 'Needed to review your application' : 'Entirely up to you'}
              checked={consents[item.key] === true}
              onChange={(value) => toggle(item.key, value)}
            />
            {notes[`consents.${item.key}`] && (
              <div style={{ marginTop: 6 }}>
                <Note>{notes[`consents.${item.key}`]}</Note>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="ob-divider">
        <div className="ob-group-label">What we do with this</div>
        <p className="ob-lede" style={{ fontSize: 14 }}>
          Your profile is read by the programme team reviewing applications. It
          is not sold, published, or shared outside the organisation. You can
          ask us to delete it at any time.
        </p>
      </div>
    </StepShell>
  );
}
